module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/bubbleBath@2x_11feda.png";